import { has } from '@pogokid/util/lodash'
import { SchemaWithId } from './types'

export function isSchemaWithId<T>(
  doc: SchemaWithId<T> | T | null | undefined
): doc is SchemaWithId<T> {
  return !!doc && has('id', doc)
}
